import { tryJsonParse, viewTransition } from '../functions.js';

export default class ConditionalRenderElement extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        _conditionalRender(this);
    }
};

function _conditionalRender(element) {

    let qsa = element.querySelectorAll.bind(element);

    function init() {
        qsa('*[x\\:conditional]').forEach((subelm) => {
            subelm.style.display = 'none';

            let conditionalSelector = subelm.getAttribute('x:conditional');

            let conditionalElement = document.querySelector(conditionalSelector);

            if (!conditionalElement) {
                return;
            }

            conditionalElement.addEventListener('change', function() {
                toggle(subelm, conditionalElement);
            });

            toggle(subelm, conditionalElement);
        });
    }

    function show(elm) {
        viewTransition(() => {
            elm.style.display = '';
        });
    }

    function hide(elm) {
        viewTransition(() => {
            elm.style.display = 'none';
        });
    }

    function toggle(targetSubelement, conditionalElement) {

        if (conditionalElement.type === 'checkbox' && conditionalElement.checked) {
            return show(targetSubelement);
        }

        let conditionalValue = targetSubelement.getAttribute('x:value');

        let jsonValue = tryJsonParse(conditionalValue);

        if (jsonValue && Array.isArray(jsonValue) && jsonValue.includes(conditionalElement.value)) {
            return show(targetSubelement);
        } 
        else if (conditionalElement.value === conditionalValue) {
            return show(targetSubelement);
        }

        return hide(targetSubelement);
    }

    init();

    return this;

};

window.customElements.define('conditional-render', ConditionalRenderElement);
